import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[alphaNumericOnly]',
})
export class AlphanumericOnlyDirective {
  // Regular expression to allow only alphanumeric characters
  private regex: RegExp = new RegExp(/^[a-zA-Z0-9]*$/);

  // List of special keys that should not be prevented
  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
  ];

  // HostListener to handle keydown events
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow special keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    // Prevent input if it doesn't match the regex
    if (!this.regex.test(event.key)) {
      event.preventDefault();
    }
  }

  // HostListener to handle paste events
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData || (window as any).clipboardData;
    let pastedInput = clipboardData.getData('text');
    // Prevent paste if it doesn't match the regex
    if (!this.regex.test(pastedInput)) {
      event.preventDefault();
    }
  }
}
